import axios from 'axios';
import { call, all, put, takeLatest, select } from 'redux-saga/effects';

import * as routedClientsReportActions from './routed-clients-report-actions';

import { saveAs } from 'file-saver';

import { GET_LIST_ALL_REQUEST, GET_LIST_SELECTS_REQUEST, SHARE_CSV } from './routed-clients-report-constants';

import notification from '~/services/notification';
import routedClientsReportServices from './routed-clients-report-service';

import { ISA_ERROR, USER_ROLE } from '~/constants';

import { AppStateType } from '../root-reducer';

import { formatDateTime, formatMessage } from '~/i18n/translate';
import { UserInterface } from '@e3labs/isa-data-dictionary';

let cancel: any;
const CancelToken = axios.CancelToken;

export function* getAllRoutedClientsReport({
  type,
  payload
}: {
  type: any;
  payload: {
    date: Date[];
    sellers: UserInterface[];
    type: string;
  };
}) {
  if (cancel !== undefined) cancel();
  const cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  });

  try {
    yield put(routedClientsReportActions.setLoadingData(true));

    const { rowsPerPage, page, order, orderBy } = yield select((state: AppStateType) => state.routedClientsReport.list);

    const params = {
      beginDate: payload?.date
        ? payload?.date[0]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      endDate: payload?.date
        ? payload?.date[1]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      userExternalCodes: payload?.sellers?.map(seller => seller.externalCode)?.join(',') ?? '',
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      order,
      orderBy
    };

    const [{ data: successRoutedClientsReports }] = yield all([
      call(
        routedClientsReportServices.getListSuccessRoutedClientsReports,
        {
          ...params
        },
        {
          cancelToken
        }
      )
    ]);

    yield put(
      routedClientsReportActions.getAllRoutedClientsReportsSuccess({
        routedClientsReports: [...successRoutedClientsReports]
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(routedClientsReportActions.setLoadingData(false));
  }
}

export function* getSelects() {
  try {
    yield put(routedClientsReportActions.setLoadingSelects(true));

    const { data: sellers } = yield call(routedClientsReportServices.getSellers);

    yield put(
      routedClientsReportActions.getListSelectsSuccess({
        selects: {
          sellers: sellers?.filter(seller => seller?.userRole === USER_ROLE?.VENDOR)
        }
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(routedClientsReportActions.setLoadingSelects(false));
  }
}

export function* shareCSV({ payload, exportType }: any) {
  const toast: any = notification.loading(formatMessage('commonLoadingMessage'));

  try {
    const params = {
      beginDate: payload?.date
        ? payload?.date[0]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      endDate: payload?.date
        ? payload?.date[1]?.toISOString().split('T')[0]
        : new Date(new Date().toISOString().split('T')[0]),
      userExternalCodes: payload?.sellers?.map(seller => seller.externalCode)?.join(',') ?? ''
    };

    if (exportType === 'xlsx') {
      let data;

      const xlsx = data?.data;

      const blob = new Blob([xlsx], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, `Relatório de Clientes Roteirizados - ${formatDateTime(new Date())}.xlsx`);
    } else {
      let data;

      data = yield call(routedClientsReportServices.getCSVSuccessDailyRouteReports, params);

      saveAs(data?.data, `Relatorio_Clientes_Roteirizados_${formatDateTime(new Date())}.csv`);
    }
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    toast.close();
  }
}

export default all([
  takeLatest(GET_LIST_ALL_REQUEST, getAllRoutedClientsReport),
  takeLatest(GET_LIST_SELECTS_REQUEST, getSelects),
  takeLatest(SHARE_CSV, shareCSV)
]);
